module.exports = __webpack_public_path__ + "static/plan-reboot-policy-95ecf3d2c8067e1c9102fb24d1f02403.png";